<template>
    <div class="p-6">
        <h4 class="text-base fony-semibold mb-8">QR Code Style</h4>
        <div class="mb-8 flex">
            <div class="w-16 text-gray-800 font-sm font-semibold leading-10 flex-shrink-0">
                <label>Color</label>
            </div>
            <div class="w-full">
                <QrcreateSfChildTab :tabs="['Solid', 'Gradient']">
                    <template #Solid>
                        <QrcreateColorFlat />
                    </template>
                    <template #Gradient>
                        <QrcreateColorGradient />
                    </template>
                </QrcreateSfChildTab>
            </div>
        </div>
        <QrcreateDotsBackgroundSetting />
        <QrcreateDotsDotSetting />
        <QrcreateDotsCornerSetting />
        <div class="mb-8 flex flex-col gap-2">
            <div class="w-full text-gray-800 font-sm font-semibold leading-10 flex-shrink-0">
                <label>Margin</label>
            </div>
            <div class="w-full flex items-center gap-1 flex-wrap">
                <input type="number" min="0" v-model="config.margin" max="100"
                    class="h-10 bg-gray-200 rounded-md px-4 w-full outline-none">
            </div>
        </div>
        <div class="mb-8 flex flex-col gap-2">
            <div class="w-full text-gray-800 font-sm font-semibold leading-10 flex-shrink-0">
                <label>Error correction</label>
            </div>
            <div class="w-full flex items-center gap-1 flex-wrap">
                <div class="flex items-center mr-4" v-for="level in levels">
                    <input :id="'inline-radio' + level.value" type="radio" v-model="config.qrOptions.errorCorrectionLevel" :value="level.value"
                        name="level-inline-radio-group"
                        class="w-4 h-4 accent-success bg-gray-100 border-gray-300 focus:ring-success focus:outline-none ">
                    <label :for="'inline-radio' + level.value"
                        class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">{{ level.label }}</label>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import configMixins from "../config.mixin"
export default defineComponent({
    mixins: [configMixins],
    setup() {

    },
    data() {
        return {
            levels: [{
                label: "7%",
                value: "L"
            },
            {
                label: "15%",
                value: "M"
            },
            {
                label: "25%",
                value: "Q"
            },
            {
                label: "30%",
                value: "H"
            },]
        }
    },
    methods: {
        changeTabs(e) {

        }
    }
})
</script>